import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { useSelectedCompany } from '../use-selected-company.hook';
import { DataRoomDetail } from './space.types';

export const useDataRoom = (id: string | undefined) => {
  const { selectedCompany } = useSelectedCompany();
  const companyId = selectedCompany?.id ?? '';

  const {
    data: dataRoom,
    isError,
    isFetched,
    isLoading,
  } = useAppQuery({
    enabled: Boolean(companyId && id),
    queryFn: () =>
      ApiService.get<DataRoomDetail>({
        endpoint: BackendRoute.DATA_ROOMS,
        routePath: [id ?? ''],
      }),
    queryKey: [QueryKey.DATA_ROOM, companyId, id],
  });

  return { dataRoom, isError, isFetched, isLoading };
};
